export const HelloWorld = {
  information:
    'このプロジェクトの設定やカスタマイズ方法に関するガイドは {0} を参照してください。',
  documentation: 'vue-cli ドキュメント',
  installed_CLI_plugins: 'インストール済み CLI プラグイン',
};
